'use strict';
// This function is used for exporters that save a JSON file with a pointer to a remote resource, instead of returning the actual result (eg Altas)
module.exports = function ExportAjaxResultLoader(ajaxProvider) {
	const self = this;
	self.load = function (exportConfig) {
		return ajaxProvider.request({
			url: exportConfig['output-url'],
			dataType: 'json'
		})
		.then(function (jsonContent) {
			return Object.assign({}, exportConfig, jsonContent);
		},
		function () {
			throw 'generation-error';
		});
	};
};

